/* lk-rx-attrs.js — Eyewear Essentials prescription flow (2026-09-12)
   One shared helper: after any cart change, summarise the prescription state
   of the whole bag into a cart attribute. Cart attributes land on the order
   under "Additional details", so staff (and Shopify Flow) can see at a glance
   whether an order needs a prescription chased on WhatsApp before lenses are cut.
   Loaded on product and cart pages. Nothing here writes to the shop. */
(function () {
  'use strict';
  var W = window, LKRX = (W.LKRX = W.LKRX || {});
  LKRX.ATTR = 'Prescription status';
  LKRX.statusFor = function (cart) {
    var rank = 0, label = 'No prescription needed';
    (cart.items || []).forEach(function (i) {
      var p = i.properties || {}, rx = String(p['Prescription'] || ''), lenses = String(p['Lenses'] || '');
      var r = 0, l = '';
      if (/whatsapp/i.test(rx)) { r = 4; l = 'Awaiting prescription on WhatsApp'; }
      else if (/quote/i.test(lenses)) { r = 3; l = 'Lens quote pending on WhatsApp'; }
      else if (/\/uploads\//.test(rx)) { r = 2; l = 'Prescription uploaded'; }
      else if (/entered/i.test(rx)) { r = 1; l = 'Prescription entered on website'; }
      if (r > rank) { rank = r; label = l; }
    });
    return label;
  };
  LKRX.syncAttributes = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var label = LKRX.statusFor(cart);
        var sameRef = true; try { var r0 = sessionStorage.getItem('lk_ref'); sameRef = !r0 || (cart.attributes || {})['Order source'] === r0; } catch (e) {}
        if ((cart.attributes || {})[LKRX.ATTR] === label && sameRef) return cart;
        var attrs = {}; attrs[LKRX.ATTR] = label;
        try { var ref = sessionStorage.getItem('lk_ref'); if (ref && (cart.attributes || {})['Order source'] !== ref) attrs['Order source'] = ref; } catch (e) {}
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
          .then(function (r) { return r.json(); });
      })
      .catch(function () { return null; });
  };
})();
